import { infoStore, ParticipationStatus } from '../../../store/infoStore';
import { useDateHook } from '../../../hook/useDateHook';
import { End } from './End';
import { Ticket } from './Ticket';

export const ProgressInfo = ({
  goMainEventTab,
  goOnlineTab,
}: {
  goMainEventTab: () => void;
  goOnlineTab: () => void;
}) => {
  const { info } = infoStore();
  const { isSatelliteEnd } = useDateHook();
  const isActiveTicket = info.status === ParticipationStatus.CHECK_ELIGIBLE;

  if (isSatelliteEnd() || info.ticketCnt === 0) {
    return <End goMainEventTab={goMainEventTab} isEarlyEnd={!isSatelliteEnd()} />;
  }

  return (
    <Ticket
      goOnlineTab={goOnlineTab}
      isActiveTicket={isActiveTicket}
      goMainEventTab={goMainEventTab}
    />
  );
};
